import React from 'react';
import { withRouter } from "react-router-dom";
import AppContext from '../../AppContext'
import {
  Button,
} from 'reactstrap';
import { FaChevronDown } from 'react-icons/fa';

import { withTranslation } from 'react-i18next';

import { isMobileSafari } from 'react-device-detect';


class MarkerOut extends React.Component {
  
    constructor(props) {
        super(props)
        
        this.state = {
            audio: "audiofile.mp3",
        }
    }

    static contextType = AppContext

    componentDidMount() {

    }

    playBackgroundAudio(source, volume) {
      console.log("MARKER OUT BACKGROUND AUDIO")


    }

    async playHeatpumpAudio(view, volume, active) {
        
      const { appVolume, heatpumpAudio, viewLocation, setHeatpumpVolume, setActiveView, setViewLocation, setViewLocationPrevious } = this.context;

      setViewLocationPrevious(viewLocation)
      setViewLocation(view);
      setHeatpumpVolume(volume);
      setActiveView(active);

      var heatpump = document.getElementById("heatpumpAudioContainer");

      if(!isMobileSafari) {
        heatpump.volume = volume*appVolume;

        if(heatpumpAudio) {
          await heatpump.play();
        }

      } else {
          
        if(heatpumpAudio) {
          heatpump.play();
        }

        this.props.gainNode.disconnect();

        this.props.gainNode.gain.value = volume*appVolume
                
        this.props.mediaSrc.connect(this.props.gainNode);
        this.props.gainNode.connect(this.props.audioCtx.destination);

        this.setState({initialVolumeSet: true})

      }
    }




     async checkDayNight() {
      const { activeView, time, viewLocation, backgroundAudio, backgroundAudioLevels, heatpumpAudioLevels } = this.context;
      
      if(time) {
        if(viewLocation === 'outdoor') {
           this.playBackgroundAudio(backgroundAudio[2],backgroundAudioLevels['outdoorNight']);
        } else {
           this.playBackgroundAudio(backgroundAudio[3],backgroundAudioLevels['indoorNight']);
        }
      } else {
        if(viewLocation === 'outdoor') {
           this.playBackgroundAudio(backgroundAudio[0],backgroundAudioLevels['outdoorDay']);
        } else {
           this.playBackgroundAudio(backgroundAudio[1],backgroundAudioLevels['indoorDay']);
        }
      }

      switch (true) {
        case (activeView === 0 && !time):
           await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor3mDay'],0);
          break;
        case (activeView === 0 && time):
            await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor3mNight'],0);
          break;
        case (activeView === 1 && !time):
           await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor1mDay'],1);
          break;
        case (activeView === 1 && time):
           await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor1mNight'],1);
          break;
        case (activeView === 2 && !time):
           await this.playHeatpumpAudio('indoor',heatpumpAudioLevels['indoorDay'],2);
          break;
        case (activeView === 2 && time):
           await this.playHeatpumpAudio('indoor',heatpumpAudioLevels['indoorNight'],2);
          break;
        default:
      }

    }

    adaptZoom(zoom) {
        this.props.action(zoom);
    }

    async changeProduct() {

      const { time, heatpumpAudioLevels } = this.context;


      switch (true) {
        case (!time):
          await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor3mDay'],0);
          await this.adaptZoom(3)
          break;
        case (time):
          await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor3mNight'],0);
          await this.adaptZoom(3)
          break;
        default:
      }

      await this.checkDayNight()
    }

    render() {

      const { t } = this.props;

          return  ( 
          <div>

            <Button onClick={(e) => { this.changeProduct() }} style={{background: 'none', borderRadius: '0px', border: 'none', fontFamily: 'Bosch-Bold', fontSize: '13px'}}>
                <div style={{position: 'relative', borderRadius: '40px', width: '40px', height: '40px', left: '50%', marginLeft: '-20px', marginBottom: '15px', background: '#038ecf', boxShadow: '0px 0px 5px 1px rgba(0,0,0,0.5)', border: 'none', fontFamily: 'Bosch-Bold'}}> <FaChevronDown style={{fontSize: '21px', marginTop: '10px'}} /> </div>
                { /*<hr style={{height: '0px', marginTop: '5px', marginBottom: '12px', borderBottom: '1px solid #000', opacity: '1'}} />*/ }
                
                <div style={{textAlign: 'center', color: '#000', background: 'rgba(255,255,255,0.75)', padding: '10px', boxShadow: '0px 0px 5px 1px rgba(0,0,0,0.5)'}}>{t('ui.navigation.3meter')}</div>
            </Button>

          </div>
          )

    }
}

export default withRouter(withTranslation()(MarkerOut));